import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFeatures } from 'selectors';

const FeatureFlagComponent = ({
  children = null,
  features,
  feature,
  fallback,
}) => {
  if (typeof children === 'function') {
    return children(features[feature]);
  }

  if (features[feature]) {
    return children;
  }
  return fallback || null;
};

FeatureFlagComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  fallback: PropTypes.node,
  feature: PropTypes.string,
  features: PropTypes.object,
};

const mapStateToProps = state => ({
  features: getFeatures(state),
});

export const FeatureFlag = connect(mapStateToProps)(FeatureFlagComponent);

export { FeatureFlagComponent };
